export const CONSENT_KEY = 'interviewgator-cookie-consent';
export const CONSENT_VERSION = '1.0';
export const CONSENT_EVENT = 'cookie-consent-changed';

export type CookieConsent = {
  accepted: boolean;
  acceptedAt: string;
  version: string;
};

export type DetailedConsent = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
};
